<template>
  <b-card no-body>
    <b-tabs card>
      <b-tab class="px-4" title="Login">
        <login-form></login-form>
      </b-tab>
      <b-tab class="px-4" title="Signup">
        <signup-form></signup-form>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import LoginForm from "@/components/credentials/LoginForm";
import SignupForm from "@/components/credentials/SignupForm";
export default {
  components: {
    LoginForm,
    SignupForm
  }
};
</script>

